import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/functions';

import clientConfig from '@config/firebase/client';
import { formatDate } from './date-time';
import {
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  NEXT_PUBLIC_FIREBASE_DB_URL,
  NEXT_PUBLIC_FIREBASE_USE_EMULATORS,
  NEXT_PUBLIC_FUNCTIONS_URL,
  STORAGE_EMULATOR_HOST,
} from '@env';

if (!firebase.apps.length) {
  firebase.initializeApp(clientConfig);
  firebase.firestore().settings({
    // ignore explicitly undefined properties
    ignoreUndefinedProperties: true,
    // This fix is to fix the firebase webchannel issue, check https://github.com/firebase/firebase-js-sdk/issues/1674
    experimentalAutoDetectLongPolling: true,
  });
}

// Setup Firebase Emulators
if (NEXT_PUBLIC_FIREBASE_USE_EMULATORS === 'true') {
  firebase.auth().useEmulator(NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN);

  const dbUrl = new URL(NEXT_PUBLIC_FIREBASE_DB_URL);
  firebase.firestore().useEmulator(dbUrl.hostname, Number(dbUrl.port));

  const storageUrl = new URL(STORAGE_EMULATOR_HOST);
  firebase.storage().useEmulator(storageUrl.hostname, Number(storageUrl.port));

  const functionsUrl = new URL(NEXT_PUBLIC_FUNCTIONS_URL);
  firebase.functions().useEmulator(functionsUrl.hostname, Number(functionsUrl.port));
}

const formatFirebaseDate = (date?: firebase.firestore.Timestamp): string =>
  date ? date.toDate().toLocaleString().split(',')[0] : '';

const formatFirebaseDateToStringDate = (date?: firebase.firestore.Timestamp): string =>
  date ? formatDate(date.toDate()) : '';

export { formatFirebaseDate, formatFirebaseDateToStringDate };

export default firebase;
